define('webshopAttributesCategoryFiltersView',[
  'module',
  'app',
  'backbone',
  'marionette',
  'underscore',
  'modalsAlertView',
  'webshopCategorySelectView',
  'webshopAttributesProductInfoView',
  'entities/webshop/attribute_matching',
  'entities/webshop/filters',
  'template!webshopAttributesCategoryFiltersView'
], function (
  Module,
  App,
  Backbone,
  Marionette,
  _,
  AlertView,
  CategorySelectView,
  ProductInfoView,
  MatchingApi,
  FiltersApi,
  Tpl
) {
  'use strict';

  var VALUES_CHUNK = 500;

  // The attributes (webshop filters) of a category page and their display order, saved in the
  // webshop (cws_category_filter). None chosen: the page shows, as before, every filter its products
  // carry. Below, the attributes used by the category's products, to pick from.
  // options: state {cat, catCode}, onState(changes)
  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'webshop-attributes-category-filters-view',

    regions: {
      categoryRegion: '.category-region'
    },

    ui: {
      chosen: '.chosen',
      used: '.used',
      add: 'select.add-attribute',
      save: '.save',
      status: '.status'
    },

    events: {
      'click .chosen .up': 'onUp',
      'click .chosen .down': 'onDown',
      'click .chosen .remove': 'onRemove',
      'change @ui.add': 'onAdd',
      'click .used .use': 'onUse',
      'click .add-all-used': 'onAddAllUsed',
      'click @ui.save': 'onSave',
      'click .reset': 'onReset',
      'change input.with-subcategories': 'onSubcategoriesChange'
    },

    initialize: function () {
      this.category = null;
      this.keys = [];
      this.chosen = [];     // filter ids, in order
      this.saved = [];
      this.otherNames = {}; // names of chosen filters that are not canonical attributes
      this.usage = null;    // keyId -> number of products of the category carrying it
    },

    serializeData: function () {
      if (this.withSub === undefined)
        this.withSub = (this.options.state || {}).sub === '1';
      return {subHtml: ProductInfoView.Helper.subHtml(this.withSub)};
    },

    // Only the "attributes of the products" help changes: the chosen filters are the category's own.
    onSubcategoriesChange: function () {
      this.withSub = this.$('input.with-subcategories').is(':checked');
      if (this.options.onState)
        this.options.onState({sub: this.withSub ? '1' : null});
      this.usage = null;
      this.render_();
      if (this.category)
        this.loadUsage(this.category);
    },

    onShow: function () {
      var state = this.options.state || {};
      if (state.cat)
        this.category = {id: state.cat, code: state.catCode || ''};

      this.getRegion('categoryRegion').show(new CategorySelectView({
        model: new Backbone.Model({id: this.category ? this.category.id : '', code: this.category ? this.category.code : ''}),
        onChange: _.bind(function (model) {
          this.category = model.get('id') ? {id: model.get('id'), code: model.get('code')} : null;
          if (this.options.onState)
            this.options.onState({cat: this.category ? this.category.id : null, catCode: this.category ? this.category.code : null});
          this.load();
          return $.Deferred().resolve().promise();
        }, this)
      }));

      this.keysRequest = MatchingApi.keys().done(_.bind(function (keys) {
        this.keys = keys;
      }, this)).fail(_.bind(this.showError, this));
      this.load();
    },

    keyOfFilter: function (filterId) {
      return _.findWhere(this.keys, {id: filterId - 9000000});
    },

    filterName: function (filterId) {
      var key = this.keyOfFilter(filterId);
      if (key)
        return MatchingApi.name(key);
      return this.otherNames[filterId] || ('#' + filterId);
    },

    //----------------
    // Loading

    load: function () {
      this.chosen = [];
      this.saved = [];
      this.usage = null;
      if (!this.category) {
        this.render_();
        return;
      }
      var category = this.category;
      this.ui.chosen.addClass('am-loading');
      $.when(this.keysRequest, FiltersApi.categoryFilters(category.id)).done(_.bind(function (keysResult, filters) {
        if (this.isDestroyed || category !== this.category)
          return;
        filters = _.isArray(filters) ? filters : [];
        this.otherNames = {};
        _.each(filters, function (f) {
          this.otherNames[f.filterId] = FiltersApi.name(f.names) || f.code;
        }, this);
        this.chosen = _.pluck(filters, 'filterId');
        this.saved = this.chosen.slice();
        this.render_();
      }, this)).fail(_.bind(function (message) {
        this.showError(message);
        this.render_();
      }, this)).always(_.bind(function () {
        if (!this.isDestroyed)
          this.ui.chosen.removeClass('am-loading');
      }, this));
      this.loadUsage(category);
    },

    // Attributes carried by the products of the category (to pick from): its products, then their
    // canonical values by chunks.
    loadUsage: function (category) {
      this.ui.used.addClass('am-loading');
      $.ajax({
        type: 'GET',
        url: App.request('webshop.category.products', category.id, ProductInfoView.Helper.productParams(this.withSub, {first: 0, pageSize: 100000})),
        success: _.bind(function (products) {
          if (this.isDestroyed || category !== this.category)
            return;
          var codes = _.pluck(products || [], 'code');
          var usage = {};
          var next = _.bind(function (index) {
            if (this.isDestroyed || category !== this.category)
              return;
            if (index >= codes.length) {
              this.usage = usage;
              this.usageTotal = codes.length;
              this.ui.used.removeClass('am-loading');
              this.render_();
              return;
            }
            MatchingApi.productValues(codes.slice(index, index + VALUES_CHUNK)).done(function (result) {
              _.each(result, function (pv) {
                _.each(_.uniq(_.pluck(pv.values, 'keyId')), function (keyId) {
                  usage[keyId] = (usage[keyId] || 0) + 1;
                });
              });
              next(index + VALUES_CHUNK);
            }).fail(_.bind(function (message) {
              this.ui.used.removeClass('am-loading');
              this.showError(message);
            }, this));
          }, this);
          next(0);
        }, this),
        error: _.bind(function () {
          this.ui.used.removeClass('am-loading');
        }, this)
      });
    },

    //----------------
    // Rendering (render_: Marionette's render keeps the template / regions)

    render_: function () {
      var dirty = this.chosen.join(',') !== this.saved.join(',');
      this.ui.save.toggleClass('off', !this.category || !dirty);
      this.ui.status.text(!this.category ? '' : dirty ?
        _.i18n('attributeMatching.unsaved', null, 'Not saved') :
        (this.saved.length ? '' : _.i18n('attributeMatching.noCategoryFilters', null,
          'None chosen: the page shows every filter its products carry.')));

      if (!this.category) {
        this.ui.chosen.html('<div class="empty">' + _.i18n('attributeMatching.pickCategory', null, 'Pick a webshop category') + '</div>');
        this.ui.used.html('');
        this.ui.add.html('').prop('disabled', true);
        return;
      }

      var html = _.map(this.chosen, function (filterId, i) {
        var key = this.keyOfFilter(filterId);
        var count = key && this.usage ? (this.usage[key.id] || 0) : null;
        return '<div class="chosen-row" data-id="' + filterId + '">' +
          '<span class="position">' + (i + 1) + '</span>' +
          '<span class="name">' + _.escape(this.filterName(filterId)) + '</span>' +
          (key && !key.showInFilters ? ' <span class="am-badge" title="' + _.escape(_.i18n('attributeMatching.notAFilterShort', null, 'Not a webshop filter')) + '">' +
            _.escape(_.i18n('attributeMatching.notFilterShort', null, 'not a filter')) + '</span>' : '') +
          (count === 0 ? ' <span class="am-hint">' + _.escape(_.i18n('attributeMatching.noProductCarries', null, 'no product of the category carries it')) + '</span>' : '') +
          (count ? ' <span class="am-hint">' + count + ' ' + _.escape(_.i18n('common.products', null, 'products')) + '</span>' : '') +
          '<span class="tools">' +
          '<span class="up ' + (i === 0 ? 'off' : '') + '" title="' + _.escape(_.i18n('attributeMatching.moveUp', null, 'Up')) + '"><i class="fa fa-arrow-up"></i></span>' +
          '<span class="down ' + (i === this.chosen.length - 1 ? 'off' : '') + '" title="' + _.escape(_.i18n('attributeMatching.moveDown', null, 'Down')) + '"><i class="fa fa-arrow-down"></i></span>' +
          '<span class="remove" title="' + _.escape(_.i18n('common.remove', null, 'Remove')) + '"><i class="fa fa-times"></i></span>' +
          '</span></div>';
      }, this).join('');
      this.ui.chosen.html(html || '<div class="empty">' + _.i18n('attributeMatching.noCategoryFiltersList', null,
        'No attribute chosen for this category: its page shows every filter its products carry.') + '</div>');

      // Add: every attribute not chosen yet, webshop filters first
      var chosen = this.chosen;
      var addable = _.sortBy(_.reject(this.keys, function (k) { return _.contains(chosen, 9000000 + k.id); }), function (k) {
        return (k.showInFilters ? '0' : '1') + MatchingApi.name(k).toLowerCase();
      });
      this.ui.add.prop('disabled', false).html('<option value="">' + _.escape(_.i18n('attributeMatching.addAttribute', null, '+ Add an attribute')) + '</option>' +
        _.map(addable, function (k) {
          return '<option value="' + k.id + '">' + _.escape(MatchingApi.name(k)) +
            (k.showInFilters ? '' : ' ' + _.escape(_.i18n('attributeMatching.notFilterSuffix', null, '(not a filter)'))) + '</option>';
        }).join(''));

      this.renderUsed();
    },

    renderUsed: function () {
      if (!this.usage) {
        this.ui.used.html('');
        return;
      }
      var chosen = this.chosen;
      var used = _.sortBy(_.filter(this.keys, function (k) { return this.usage[k.id]; }, this), function (k) {
        return -this.usage[k.id];
      }, this);
      var html = _.map(used, function (k) {
        var isChosen = _.contains(chosen, 9000000 + k.id);
        return '<div class="used-row ' + (isChosen ? 'chosen-already' : '') + '" data-key="' + k.id + '">' +
          '<span class="name">' + _.escape(MatchingApi.name(k)) + '</span>' +
          (k.showInFilters ? '' : ' <span class="am-badge">' + _.escape(_.i18n('attributeMatching.notFilterShort', null, 'not a filter')) + '</span>') +
          '<span class="am-hint">' + this.usage[k.id] + ' / ' + this.usageTotal + ' ' + _.escape(_.i18n('common.products', null, 'products')) + '</span>' +
          (isChosen ? '' : '<span class="use"><i class="fa fa-plus"></i> ' + _.escape(_.i18n('attributeMatching.add', null, 'Add')) + '</span>') +
          '</div>';
      }, this).join('');
      this.ui.used.html(html || '<div class="empty">' + _.i18n('attributeMatching.noUsedAttribute', null, 'No product of the category carries an attribute') + '</div>');
      this.$('.add-all-used').toggle(_.some(used, function (k) { return k.showInFilters && !_.contains(chosen, 9000000 + k.id); }));
    },

    //----------------
    // Editing

    rowId: function (e) {
      return parseInt($(e.currentTarget).closest('.chosen-row').data('id'), 10);
    },

    move: function (filterId, delta) {
      var i = _.indexOf(this.chosen, filterId);
      var j = i + delta;
      if (i < 0 || j < 0 || j >= this.chosen.length)
        return;
      this.chosen[i] = this.chosen[j];
      this.chosen[j] = filterId;
      this.render_();
    },

    onUp: function (e) { this.move(this.rowId(e), -1); },
    onDown: function (e) { this.move(this.rowId(e), 1); },

    onRemove: function (e) {
      this.chosen = _.without(this.chosen, this.rowId(e));
      this.render_();
    },

    onAdd: function () {
      var keyId = parseInt(this.ui.add.val(), 10);
      if (keyId)
        this.chosen.push(9000000 + keyId);
      this.render_();
    },

    onUse: function (e) {
      this.chosen.push(9000000 + parseInt($(e.currentTarget).closest('.used-row').data('key'), 10));
      this.render_();
    },

    // Every webshop filter used by the products, most used first
    onAddAllUsed: function () {
      var used = _.sortBy(_.filter(this.keys, function (k) { return this.usage[k.id] && k.showInFilters; }, this), function (k) {
        return -this.usage[k.id];
      }, this);
      _.each(used, function (k) {
        if (!_.contains(this.chosen, 9000000 + k.id))
          this.chosen.push(9000000 + k.id);
      }, this);
      this.render_();
    },

    onReset: function () {
      this.chosen = this.saved.slice();
      this.render_();
    },

    onSave: function () {
      if (!this.category)
        return;
      var category = this.category;
      this.ui.save.addClass('off');
      FiltersApi.updateCategoryFilters(category.id, this.chosen).done(_.bind(function (result) {
        if (this.isDestroyed || category !== this.category)
          return;
        this.saved = (result && result.filterIds) || this.chosen.slice();
        this.chosen = this.saved.slice();
        this.render_();
        this.ui.status.text(_.i18n('attributeMatching.categoryFiltersSaved', null, 'Saved: the category page is refreshed by the cache job.'));
      }, this)).fail(_.bind(function (message) {
        this.showError(message);
        this.render_();
      }, this));
    },

    showError: function (message) {
      AlertView.prototype.open('', message);
    }
  });
});

